<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
            <v-card outlined shaped class="elevation-4">
                <ValidationObserver ref="refVenta" v-slot="{ invalid, validated }">
                    <v-form name="form" @submit.prevent="saveSell">       
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click.native="handleModal">
                                <v-icon>fas fa-times-circle</v-icon>
                            </v-btn>
                            <v-toolbar-title>
                                <div class="text-h6 font-weight-bold white--text text-uppercase">
                                    MOSTRADOR - Granja san Fernando S.A DE C.V.
                                </div>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn color="primary" type="submit" tile dark align="right"
                                :disabled="isSubmitting || invalid || !validated"
                                :loading="isSubmitting">
                                    <v-icon class="ma-2" dense large left>fas fa-save</v-icon> 
                                    {{ titleButtonOut }}
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col :cols="computedCol" :md="computedCol" sm="12">
                                    <v-row class="pa-0">
                                        <!-- <v-col cols="12" sm="4" md="4">
                                            <v-text-field label="Ticket de venta*" prepend-inner-icon="fas fa-ticket-alt"
                                            solo-inverted
                                            disabled v-model="venta.ticketFolio"></v-text-field>
                                        </v-col> -->
                                        <v-col cols="12" sm="4" md="4">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="tipoSalida" item-text="nombre" item-value="id"
                                                prepend-inner-icon="fas fa-outdent" hint="Selecciona el tipo de salida."
                                                v-model="venta.tipoSalidaId" label="Tipo salida" required outlined 
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeMovement">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="sucursales" item-text="nombre" item-value="id" v-model="venta.sucursalEnviaId"
                                                label="Sucursal envia" required outlined prepend-inner-icon="fas fa-id-card-alt"
                                                :readonly="!isAdmin"
                                                hint="Seleccione la sucursal a trasladar" :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeMovement">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="listEntradaDetalle" item-text="ticketFolio" item-value="id" v-model="venta.entradaDetalleId"
                                                label="Entrada de inventario" required outlined prepend-inner-icon="fas fa-layer-group" chips small-chips
                                                hint="Seleccione la entrada de inventario" :error-messages="errors" :success="valid">
                                                <!-- hide-details hide-selected -->
                                                    <template v-slot:no-data>
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                No hay entradas
                                                                <strong> para la sucursal seleccionada</strong>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                    <template v-slot:item="{ item }">
                                                        {{ item.ticketFolio }} - {{ item.producto.nombre }} {{ item.producto.descripcion }} Existencia: <strong> {{ item.existencia }}</strong>
                                                    </template>
                                                    <template v-slot:selection="{ attr, on, item, selected }">
                                                        <v-chip v-bind="attr" :input-value="selected" color="blue darken-3"
                                                        class="white--text font-weight-bold rounded p-0" v-on="on">
                                                            <span v-text=" item.producto.nombre + ' ' + item.producto.descripcion + ' Existencia: '+ item.existencia + ' - ' +item.ticketFolio"></span>
                                                        </v-chip>
                                                    </template>
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeTransfer">
                                            <ValidationProvider :rules="modeMerma ? '' : 'required'" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="excludeSucursalEnvia" item-text="nombre" item-value="id" v-model="venta.sucursalRecibeId"
                                                label="Sucursal recibe" required outlined prepend-inner-icon="fas fa-id-card-alt"
                                                hint="Seleccione la sucursal a trasladar" :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeSell">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid }" :immediate="true">
                                                <v-autocomplete :items="clientes" item-text="nombreComercial" item-value="idCliente" v-model="venta.clienteId"
                                                label="Cliente" required outlined prepend-inner-icon="fas fa-id-card-alt" hint="Seleccione un cliente, es opcional"
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeSell && venta.clienteId == 29">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="employees" item-text="nombreCompleto" item-value="id" v-model="venta.employeeId"
                                                label="Empleado" required outlined prepend-inner-icon="fas fa-id-card-alt" hint="Seleccione un empleado"
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeSell && clientesSucursal.length > 0">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="clientesSucursal" item-text="name" item-value=id v-model="venta.clienteSucursalId"
                                                label="Sucursal" required outlined prepend-inner-icon="fas fa-id-card-alt" hint="Seleccione una sucursal"
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeSell">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="tipoPagos" item-text="formaPago" item-value="id" v-model="venta.tipoPagoId"
                                                label="Medio de Pago" outlined prepend-inner-icon="fas fa-file-invoice-dollar"
                                                :error-messages="errors" :success="valid" :disabled="!hasCredit">
                                                <!-- <template v-slot:item="{ item }">
                                                    <v-list-item :disabled="!hasCredit">
                                                        <v-list-item-content>{{ item.formaPago }}</v-list-item-content>
                                                    </v-list-item>
                                                </template> -->
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4" v-if="modeSell">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="monedas" item-text="moneda" item-value="id" v-model="venta.tipoMonedaId"
                                                label="Moneda*" required solo-inverted prepend-inner-icon="fas fa-wallet" disabled
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" v-if="modeSell && venta.tipoPagoId === 1">
                                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                                <v-autocomplete :items="paymentMethod" item-text="name" item-value="value"
                                                v-model="venta.paymentMethod" label="Metodo de pago*" prepend-icon="fas fa-credit-card"
                                                :error-messages="errors" :success="valid">
                                                </v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" v-if="enableOperationNumber">
                                            <ValidationProvider :rules="enableOperationNumber ? 'required': ''" v-slot="{ errors, valid }" :immediate="true">
                                                <v-text-field label="Numero/referencia de la operación" prepend-icon="fas fa-receipt"
                                                v-model="venta.operationNumber" :error-messages="errors" :success="valid" required :counter="100">
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4" class="pa-0">
                                            <SingleCalendar refElement="deliveryDate" :input-date.sync="venta.deliveryDate"
                                            title="Fecha de entrega" :min-date="today" text-hint="Seleccione solo si aplica"/>
                                        </v-col>
                                         <!-- add evidences -->
                                         <v-col cols="12" xs="12" md="4" v-if="modeMerma || enableOperationNumber">
                                            <template>
                                                <v-file-input v-model="fileEvidences" color="deep-purple accent-4" counter
                                                    :show-size="true" :rules="fileRules"
                                                    label="Adjuntar archivo" :multiple="false" placeholder="Seleccionar archivo" prepend-icon="fas fa-paperclip"
                                                    outlined dense class="mt-2">
                                                        <template v-slot:selection="{ index, text }">
                                                            <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small >
                                                                {{ text }}
                                                            </v-chip>
                                                            <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                                                +{{ files.length - 2 }} Archivos
                                                            </span>
                                                        </template>
                                                </v-file-input>
                                            </template>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4">
                                            <v-chip class="text-h3 font-weight-regular white--text filterSubtotal w-100"
                                            :color="modeMerma ? 'red darken-3' : 'green darken-4'"
                                            label text-color="white" large>
                                                <v-icon left>fas fa-dollar-sign</v-icon> {{importeNatural}}
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <!-- <v-autocomplete :items="productos" item-text="nombre" item-value="id"
                                            :search-input.sync="search" :loading="isLoading" hide-selected
                                            chips outlined v-model="venta.productoId" label="Escriba el nombre del producto" 
                                            prepend-inner-icon="fas fa-store-alt" hint="Buscar los productos que desee vender">
                                            </v-autocomplete> -->
                                        
                                            <addProducto :venta.sync="venta" :products.sync="products" ref="myCartProduct"
                                            :listEntradaDetalle.sync="listEntradaDetalle"
                                            @getDetailProduct="getDetailProduct" @addProductCart="addProductCart">
                                            </addProducto>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="3" sm="12" lg="3" v-if="modeSell">
                                    <v-alert class="calendario" color="primary" icon="fas fa-calendar-check" prominent type="success">
                                        {{fullDateNatural}}
                                    </v-alert>
                                    <!-- Details product -->
                                    <DetailProductInStock :product-in-stock="detailProduct" v-if="showDetail && modeSell"/>
                                    <DetailCreditClient :client-id="venta.clienteId"
                                    @creditClient="onCreditClient"
                                    v-if="modeSell && venta.clienteId"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </ValidationObserver>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import ProductoDataService from "@/service/producto/ProductoDataService";
import ProductoListaPrecioDataService from "@/service/producto/ProductoListaPrecioDataService";
import VentaDataService from '@/service/venta/VentaDataService';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import addProducto from './addProduct.vue';
import DetailProductInStock from "./DetailProductInStock.vue";
import { getFullDateTodayNatural, getHourNowNatural, getToday } from "@/utils/DateUtil";
import EntradaDetalleDataService from "@/service/entrada/EntradaDetalleDataService";
import UsuarioDataService from "@/service/usuario/UsuarioDataService";
import DetailCreditClient from "../cliente/DetailCreditClient.vue";
import VentaEvidenceFileService from "@/service/venta/evidences/VentaEvidenceFileService";
import SingleCalendar from "@/components/shared/SingleCalendar.vue";
import EmpleadoDataService from "@/service/empleado/empleadoDataService";
import ClienteSucursalDataService from "@/service/cliente/clienteSucursalDataService";

export default {
    name: "NuevaVenta",
    components: { addProducto, DetailProductInStock, DetailCreditClient, SingleCalendar },
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        initialize: { type: Function },
        monedas: { type: Array, default: () => [] },
        clientes: { type: Array, default: () => [] },
        tipoSalida: { type: Array, default: () => [] },
        tipoPagos: { type: Array, default: () => [] },
        sucursales: { type: Array, default: () => [] }
    },
    created () { this.getAllServices() },
    data () {
        return {
            products:   [],
            services:   [],
            employees:  [],
            clientesSucursal: [],
            listEntradaDetalle: [],
            detailProduct:  [],
            importeNatural: 0,
            today: getToday().toFormat('yyyy-MM-dd'),
            venta: {
                sucursalEnviaId: null,
                sucursalRecibeId: null,
                clienteId:      null,
                employeeId:     null,
                clienteSucursalId: null,
                entradaDetalleId: null,
                tipoPagoId:     1,
                tipoMonedaId:   1,
                tipoSalidaId:   1,
                ticketFolio:    '',
                total:          0,
                productoId:     null,
                eliminado:      false,
                paymentMethod:  '',
                operationNumber: '',
                deliveryDate: null,
            },
            creditClient: {},
            productCart: [],
            paymentMethod: [ 'EFECTIVO', 'TRANSFERENCIA', 'CHEQUE'],
            search: null,
            isLoading: false,
            fileEvidences: undefined,
            fileRules: [
                value => !value || value.size < 5000000 || 'El archivo debe ser menor a 5 MB!'
            ],
            isSubmitting: false,
        }
    },
    methods: {
        // TO GET ALL PRODUCTS in MERMAS and SALIDAS.
        async getAllProduct(){ this.products = await ProductoDataService.findAll().then( resp => resp.data ) || [] },
        async getAllServices(){
            const typeService = true;
            this.services = await ProductoDataService.findAll(typeService).then( resp => resp.data ) || []
        },
        async getAllEmployees(){
            this.employees = await EmpleadoDataService.all().then( resp => resp.data ) || [];
        },
        async getClientSucursal( clientId ) {
            ClienteSucursalDataService.findAllByClient( clientId ).then( result => {
                this.clientesSucursal = result.data;
            }).catch( error => {
                this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Error', text: error.response.data, showConfirmButton: false, timer: 4000 });
                this.clientesSucursal = [];
            });
        },
        async getUltimateSell(){
            this.ultimateSell = await VentaDataService.ultimateSell().then( resp => resp.data.row[0] ) || [];
            this.venta.ticketFolio = this.ultimateSell.ticketFolio;
        },
        
        async getListaPrecioProducto( clienteId ){
            const productPrice = await ProductoListaPrecioDataService.findByClienteId( clienteId ).then( resp => resp.data ) || [];
            if( productPrice.length == 0 ){
                this.$swal.fire({ icon: 'error', title: 'No hay precio asignado para este cliente',
                text:'Por lo tanto, no es posible vender, favor de solicitar asignar precio con su administrador de clientes',
                showConfirmButton: false, timer: 5000 });
            } else {
                const products =  productPrice.map( prodClient => {
                    const product = prodClient.producto;
                    product.precioVenta = prodClient.precioVenta;
                    product.minPrice = prodClient.minPrice;
                    product.listaPrecioId = prodClient.listaPrecioId;
                    return product;
                });
                const services = this.services.map( service => {
                    const product = service;
                    product.precioVenta = service.amountSell;
                    product.minPrice = service.amountSell;
                    product.listaPrecioId = null;
                    return product;
                })
                this.products = [...products, ...services];
            }
        },
        addProductCart(products){
            this.productCart = products;
            const total = products.reduce( (acm, item) => acm + item.total, 0 );
            this.venta.total = total;
            this.importeNatural = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        getDetailProduct( data ){
            this.detailProduct = data;
        },
        getListaEntradaDetalle( sucursalId, typeOutId ){
            EntradaDetalleDataService.getEntradaDetalleBySucursal( sucursalId, typeOutId ).then( result => {
                const data = result.data || [];
                this.listEntradaDetalle = (typeOutId == 4)
                ? data.filter(prod => prod?.producto?.hasProcess)
                : data;
            }).catch( err => {
                this.$swal.fire({icon: 'error', title: 'Entradas no encontradas', html: err, showConfirmButton: false, timer: 3500 });
            })
        },
        selectedProductInEntradaDetalle( entradaDetalleId ){
            if( this.listEntradaDetalle.length > 0 && entradaDetalleId > 0 ){
                this.products = this.listEntradaDetalle.filter( productEntry => productEntry.id == entradaDetalleId )
                .map( productEntryDetail => {
                    let product = productEntryDetail.producto;
                    product.precioVenta = productEntryDetail.precioUnitario;
                    product.minPrice = productEntryDetail.precioUnitario;
                    product.listaPrecioId = null
                    product.entradaDetailId = productEntryDetail.id
                    return product;
                })
            }
        },
        allowToSell(){
            if( this.modeSell){
                const { balance, balanceNatural, allowToBuy } = this.creditClient;
                const { total, tipoPagoId } = this.venta;
                if( total > balance && tipoPagoId == 2 && !allowToBuy ){
                    this.$swal.fire({ icon: 'error', title: 'No tiene suficiente saldo',
                    html: `<h2>Su credito es de: <b>${balanceNatural}</b></h2><h2>Su compra ${this.importeNatural} rebasa el credito: <b>${balanceNatural}</b></h2>`,
                    showConfirmButton: false, timer: 3500 });
                    return false;
                }
            }
            return true;
        },
        async uploadEvidences(ventaId) {
            try {
                const rsp = await VentaEvidenceFileService.uploadEvidence(this.fileEvidences, ventaId);
                this.initialize();
                this.handleModal();
                this.fileEvidences = undefined;
                this.$swal.fire({ icon: 'success', title: `${this.getTitleModule} registrada correctamente`, text: rsp.data.message, showConfirmButton: false, timer: 3500 });
            } catch (err) {
                this.handleModal();
                this.initialize();
                this.fileEvidences = undefined;
                this.$swal.fire({ icon: 'error', title: `${this.getTitleModule} registrada correctamente`, text: "Ocurrio un error al subir la evidencia", showConfirmButton: false, timer: 3500 });
            }
        },
        async saveSell(){
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.$refs.refVenta.validate().then( async isValid => {

                if( isValid ){
                    if ( this.productCart.length == 0){
                        this.$swal.fire({ icon : 'info',
                            title : `No es posible generar una ${this.getTitleModule}, si no hay al menos un producto.`,
                            showConfirmButton : false, timer : 5000
                        });
                        this.isSubmitting = false;
                        return;
                    }
                    if(this.allowToSell()){
                        try {
                            const response = await VentaDataService.create( this.venta, this.productCart );
                            if(response.status == 200){
                                if (this.fileEvidences !== undefined && (this.modeMerma || this.enableOperationNumber)) {
                                    await this.uploadEvidences(response.data.id);
                                } else {
                                    this.initialize();
                                    this.handleModal();
                                    this.fileEvidences = undefined;
                                    this.$swal.fire({ icon: 'success', title: `${this.getTitleModule} registrada correctamente`, text: response.data.message, showConfirmButton: false, timer: 5000 });
                                }
                            }
                        } catch (error) {
                            this.$swal.fire({icon: 'error', title: `${this.getTitleModule} no registrado`,
                                html: error?.response?.data,
                                showConfirmButton: false, timer: 7000
                            });
                        } finally {
                            this.isSubmitting = false;
                        }
                    } else {
                        this.isSubmitting = false;
                    }
                } else {
                    this.isSubmitting = false;
                }
            }).catch( err => {
                this.$swal.fire({ icon: 'error', title: `${this.getTitleModule} no registrado, validar campos`, text: err, showConfirmButton: false, timer: 5000 });
                this.isSubmitting = false;
            }).finally( () => {
                this.isSubmitting = false;
            });
        },
        onCreditClient( creditClient){
            this.creditClient = creditClient
        }
    },
    watch: {
        'venta.tipoSalidaId': function( newValue ){
            this.venta.sucursalRecibeId = null
            const currentSucursalId = SucursalDataService.getCurrentSucursalId();
            if([2, 4].includes( newValue ) && currentSucursalId != null){
                this.venta.sucursalEnviaId = currentSucursalId;
                this.venta.sucursalRecibeId = currentSucursalId;
            }
            if ([2, 3, 4].includes(newValue)) {
                this.venta.sucursalEnviaId = currentSucursalId;
                this.venta.clienteId = null; // Reset client ID
                // this.getAllProduct();
                this.getListaEntradaDetalle( this.venta.sucursalEnviaId, newValue );
            }
            this.$refs.myCartProduct.productCart = [];
            this.products = [];
            this.venta.entradaDetalleId = null;
            if( newValue == 1 ){
                this.detailProduct = [];
                if( this.venta.clienteId != null ){
                    this.getListaPrecioProducto( this.venta.clienteId );
                }
            }
        },
        'venta.sucursalEnviaId': function( newValue ){
            if( newValue != null ){
                this.getListaEntradaDetalle( newValue, this.venta.tipoSalidaId );
            }
        },
        'venta.clienteId':function( newValue ){
            if( newValue != null ){
                // TODO: Refactor this code in the future cause it is hardcoded the client with ID 27 reference to CONSUMO PERSONAL
                if(newValue == 29){
                    this.getAllEmployees();
                } else {
                    this.venta.employeeId = null;
                }
                this.venta.clienteSucursalId = null;
                this.getClientSucursal( newValue );
                this.$refs.myCartProduct.productCart = [];
                this.getListaPrecioProducto( newValue );
            }
        },
        'venta.entradaDetalleId': function( newValue ){
            this.$refs.myCartProduct.productCart = [];
            this.products = [];
            if( newValue != null ){
                this.selectedProductInEntradaDetalle( newValue );
            }
        },
        search() {
            if (this.productos.length > 0) return
            this.isLoading = true
            ProductoDataService.findAll().then( resp => {
                this.productos = resp.data.rows;
            }).catch( err => {
                this.$swal.fire({ icon: 'error', title: 'Error al cargar los productos', text: err.response.data, showConfirmButton: false, timer: 3500 });
            }).finally( () => this.isLoading = false )
        }
    },
    computed: {        
        isAdmin(){ return UsuarioDataService.getUserRoles().includes('ROLE_ADMIN'); },
        fullDateNatural() { return getFullDateTodayNatural() + " - " + getHourNowNatural(); },
        modeSell() { return this.venta.tipoSalidaId == 1 || this.venta.tipoSalidaId == 5; },
        modeMovement() { return this.venta.tipoSalidaId == 2 || this.venta.tipoSalidaId == 3 || this.venta.tipoSalidaId == 4; },
        modeMerma() { return this.venta.tipoSalidaId == 2; },
        modeTransfer() { return this.venta.tipoSalidaId == 3 },
        modeProcess() { return this.venta.tipoSalidaId == 4; },
        modeInternalSell() { return this.venta.tipoSalidaId == 5; },
        showDetail() {
            return this.modeSell && this.detailProduct.length > 0;
        },
        excludeSucursalEnvia() {
            return this.sucursales.filter( sucursal => sucursal.id != this.venta.sucursalEnviaId );
        },
        enableOperationNumber(){
            return (this.venta.paymentMethod == "TRANSFERENCIA" || this.venta.paymentMethod == "CHEQUE") && this.venta.tipoPagoId == 1 && !this.modeMovement;
        },
        isContado(){ return this.venta.tipoPagoId == 1; },
        checkClient(){ return this.venta.clienteId == this.creditClient.idCliente; },
        hasCredit(){
            if( this.venta.clienteId != null ){
                const { hasCredito } = this.clientes.find( client => client.idCliente == this.venta.clienteId );
                if( !hasCredito ){
                    this.venta.tipoPagoId = 1
                }
                return hasCredito;
            }
            this.venta.tipoPagoId = 1
            return false;
        },
        computedCol() {
            return !this.modeSell ? 12 : 9
        },
        getTitleModule(){
            const titles = { 1: 'Venta', 2: 'Merma', 3: 'Salida por traspaso', 4: 'Salida por proceso', 5: 'Venta Interna' };
            return titles[this.venta.tipoSalidaId] || ' Venta';
        },
        titleButtonOut(){
            return (this.isSubmitting ? 'Guardando...' : 'Guardar') + ' ' + this.getTitleModule;
        }
    }
}
</script>
<style scoped>
    .busqueda {
        margin-bottom: 0in;
    }
    .v-input .v-label{
        font-size: 20px;
        font-weight: 600;
    }
</style>